var product = {

    init: function () {
        this.setListeners();
    },

    setListeners: function () {
        var $this = this;

        // Gestion de la wishlist
        $('.line-about .share.list')  
            .on('click', function (e) {
                var idproduit = $(this).data('idproduit');
                $.get('/websvc/modalbox.ws.php?template=addwhishlist&idproduit=' + idproduit + '&nocache=' + Math.random())
                    .done(function (data, status, xhr) {

                        popin.open(data.html);

                        var $popin = $(popin.selector);

                        $popin
                            .on('click', 'a.addInWishlist', function () {
                                var qte = $('#m_qte').val();
                                var idWishlist = $(this).data('id');
                                var idProduit = $(this).data('product');

                                $.post('/websvc/wishlistV2.ws.php', {
                                        idWishlist: idWishlist,
                                        idProduit: idProduit,
                                        qte: qte,
                                        action: 'addProduit'
                                    },
                                    function (data) {
                                        $('#add_' + idWishlist + '_' + idProduit)
                                            .removeClass('addInWishlist')
                                            .removeClass('btn-primary')
                                            .addClass('btn-dark disabled')
                                            .html('Ajout&eacute; &agrave; la liste');
                                    });
                            });
                    });
            });

        // Affichage des liens de Réseaux sociaux
        $('.line-about .share.social')
            .on('click', function (e) {
                e.preventDefault();
                $('.social_buttons').toggleClass('visible');
            });

        // Liens Email, FB, G+
        $('.line-about .social_buttons').on('click', function(e) {
            if ($(e.target).is('.social_buttons.visible')) {
                $('.social_buttons').removeClass('visible');
            }
        });


        // Liens Email, FB, G+
        $('.line-about .social_buttons .social_button')
            .on('click', function (e) {
                e.preventDefault();

                if ($(this).hasClass('button_facebook')) {
                    var socialLink = 'https://www.facebook.com/sharer/sharer.php?u=';
                    window.open(socialLink + location.href);
                }
                // else if ($(this).hasClass('button_gplus')) {
                //     socialLink = 'https://plus.google.com/share?url=';
                //     window.open(socialLink + location.href);
                // }
                else {
                    var idproduit = $(this).data('idproduit');
                    $.get('/websvc/modalbox.ws.php?template=sendFriend&idproduit=' + idproduit + '&nocache=' + Math.random())
                        .done(function (data, status, xhr) {

                            popin.open(data.html);

                            var $popin = $(popin.selector);

                            $popin
                                .on('click', '#validSendFriend', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    var msg = '';
                                    var nom = $('#nomExp').val();
                                    var nom2 = $('#friendName').val();
                                    var mail = $('#mailExp').val();
                                    var mail2 = $('#friendEmail').val();
                                    var nbMailok = 0;
                                    var regex = /\w+((-\w+)|(\.\w+)|(\_\w+))*\@[A-Za-z0-9]{2,}((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]{2,6}/;

                                    if (mail == '' || nom == '') {
                                        msg = __("sendFriend_err3");
                                    }

                                    if (!regex.test(mail)) {
                                        msg = __("sendFriend_err2");
                                    }

                                    if (mail2 != '' && nom2 != '' && regex.test(mail2)) {
                                        nbMailok++;
                                    }

                                    if (nbMailok == 0) {
                                        msg = __('sendFriend_err1');
                                    }

                                    if (msg == '') {
                                        $.get("/websvc/modalbox.ws.php", $("#sendFriend").serialize())
                                            .done(function (data) {
                                                if ($.trim(data) != '') {
                                                    $('#page-popin').html(data.html);
                                                    $('body')
                                                        .on('click', 'button#back', function(e) {
                                                            $('#page-popin').fadeOut(200).remove();
                                                        });
                                                }
                                            });
                                    }
                                    else {
                                        alert(msg);
                                    }
                                });

                            filledInputs.init();
                        });
                }

            });

        // OUverture fancybox
        $('.big-img')
            .on('click', 'a', function (e) {
                e.preventDefault();
                product.ouvrirFancyBox();
            });

        // On ne déclenche rien si on est sur la version "mobile" du menu
        if (window.matchMedia("(max-width: 992px)").matches) {
            // OUverture fancybox
            $('.big-img2')
                .parent().on('click', 'a.linkImageProductBig', function (e) {
                e.preventDefault();
                product.ouvrirFancyBox();
            });

            // Ouverture avis
            $('.line-about').on('click', 'a.link_reviews', function(e) {
                var link = $('#review-nav > a');
                if (link.hasClass('collapsed')) {
                    link.trigger('click');
                }
            })
        }

        /** Gere evenement FancyBox et evenement pour afficher l'image en plus grand quand on clique sur la vignette **/
        $('.carousel-thumb').find('a.linkImageProduct')
            .on('click', function (e) {
                e.preventDefault();
                var type = $(this).find('[data-type]').data('type');
                var numero = $(this).data('numero');

                $('.big-img a').attr('data-numero', numero);
                $('.big-img2 a').attr('data-numero', numero);

                if (type == 'image') {
                    product.afficherImage($(this));
                }
                else if (type == 'video') {
                    product.afficherVideo($(this));
                }
            });
    },


    /**
     * Ouvre la FancyBox avec l'album des images du produit.
     */
    ouvrirFancyBox: function () {
        var $this = this;
        var tabMedia = new Array;

        $('.product-page').find('.carousel-thumb a.linkImageProduct img').each(function () {
            if ($(this).data('type').length > 0 && $(this).data('type') == 'image') {
                tabMedia.push({
                    src: $(this).data('img_full'),
                    opts: {
                        thumb: $(this).attr('src'),
                        defaultType: 'image',
                    }
                });
            }
            else {
                tabMedia.push({
                    src: $(this).data('img_full'),
                    opts: {
                        thumb: $(this).attr('src'),
                        defaultType: 'video',
                    }
                });
            }
        });

        var numero = $('.big-img a').data('numero') - 1;

        $.fancybox.open(tabMedia, {
            nextEffect: 'none',
            prevEffect: 'none',
            index: numero,
            helpers: {
                title: null,
                overlay: {
                    closeClick: true
                },
                thumbs: {
                    position: 'bottom',
                    width: 60,
                    height: 60,
                    source: function (item) {
                        return item.miniature;
                    }
                }
            }
        });
    },


    /**
     * Methode a utiliser pour afficher l'image plus grande (sans Fancybox) lorsque l'on clique sur une vignette.
     */
    afficherImage: function ($a) {
        $this = this;
        var $big_picture = $('.big-img');
        var $img = $big_picture.find('a > img');
        var $load = $img.prev('.load');
        var lien = $a.find('img').data('img');

        /** Supprime l'eventuel video avant d'afficher l'image **/
        if ($big_picture.find('object').length > 0) {
            $big_picture.find('a').show();
            $big_picture.find('object').remove();
        }

        $img.hide();
        $load.show();

        var lien_anti_cache = lien + '?' + new Date().getTime();
        $img.attr('src', lien_anti_cache);

        $img.on('load', function () {
            $load.hide();
            $big_picture.find('a').data('numero', $a.data('numero'));
            $img.show();
        });
    },


    /**
     * Methode a utiliser pour afficher la video plus grande (sans Fancybox) lorsque l'on clique sur une vignette.
     */
    afficherVideo: function ($a) {
        var $this = this;
        var $big_picture = $('.big-img');

        var $width_video = $big_picture.css('width').replace(/[^-\d\.]/g, '');
        var $height_video = $width_video * 300 / 400;

        var $object = '<object type="application/x-shockwave-flash" data="' + $this.urlPlayer + '" width="' + $width_video + '" height="' + $height_video + '>'
            + '<param name="movie" value="' + $this.urlPlayer + '" />'
            + '<param name="allowFullScreen" value="true" />'
            + '<param name="FlashVars" value="flv=' + $a.find('[data-url_video]').data('url_video') + '&width=' + $width_video + '&height=' + $height_video + '&autoplay=1" />'
            + '</object>';

        /** Ajoute la video si celle-ci n'est pas deja presente **/
        if (typeof $big_picture.find('object') == 'undefined' || $big_picture.find('object').length == 0) {
            $big_picture.find('a').hide();
            $big_picture.append($object);
        }
    },
};


(function ($) {
    product.init();
})(jQuery);